import { baseClient } from '../common';
import { SiteUnitModel } from './site-unit.model';
import { SiteUnitListModel } from './site-unit-list.model';

const apiUrl = `/api/site-units`;

export const siteUnitClient = {
  search: (): Promise<SiteUnitListModel[]> => {
    return baseClient.get<SiteUnitListModel[]>(`${apiUrl}/list`);
  },

  get: (siteUnitId: string): Promise<SiteUnitModel> => {
    return baseClient.get<SiteUnitModel>(`${apiUrl}/${siteUnitId}`);
  },

  unlock: (code: string): Promise<void> => {
    return baseClient.body<{ siteUnitCode: string }, void>({
      url: `${apiUrl}/unlock`,
      method: 'POST',
      body: { siteUnitCode: code },
    });
  },
};
